var React = require('react');

function ArrowLeft (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M5.12,27.79,23.3,12.71l-1.55-1.83L0,29.05,21.75,47.13l1.57-1.84L5.12,30.21H58V27.79Z","transform":"translate(0 -10.88)","style":{"fillRule":"evenodd"}}));
}

ArrowLeft.defaultProps = {"id":"aef8f84d-8ef5-4ab6-9630-1c1232bdd270","data-name":"bf2db89f-8079-469e-ad59-eed45e816ce7","viewBox":"0 0 58 36.25","width":"100%","height":"100%"};

module.exports = ArrowLeft;

ArrowLeft.default = ArrowLeft;
